import { ActionKind, HydratedSortAction, Schema, SortOrderKind } from "../shared";
import { getColumnDefByJsonKey } from "../helpers";

const getSortAction = (
  s: Schema,
  jsonKey: string,
  sortOrder: SortOrderKind,
): HydratedSortAction => {
  const def = getColumnDefByJsonKey(s, jsonKey);
  const { displayName } = def;

  return {
    kind: ActionKind.Sort,
    jsonKey,
    sortOrder,
    displayText:
      sortOrder === SortOrderKind.Ascending
        ? `${displayName}, ascending`
        : `${displayName}, descending`,
  };
};

export default getSortAction;
